const LEGACY_LEVEL_NAMES = {
  0: '免费体验',
  1: '冒险新星',
  2: '音乐勇者',
  3: '乐理大师',
  4: '音乐王者'
}

/** 用户全局展示的 VIP 名称（优先后台套餐名） */
export function resolveUserVipDisplayName(user) {
  if (!user) {
    return '免费体验'
  }
  if (user.vip_display_name) {
    return user.vip_display_name
  }
  const bankVips = user.bank_vips || []
  if (bankVips.length) {
    const named = bankVips.filter((v) => v && v.package_name)
    if (named.length) {
      return named[named.length - 1].package_name
    }
  }
  const lv = parseInt(user.vip_level, 10) || 0
  return LEGACY_LEVEL_NAMES[lv] || '免费体验'
}

/** 单个题库的会员展示名 */
export function resolveBankVipDisplayName(bank) {
  if (!bank) {
    return ''
  }
  if (bank.entitlement_package_name) {
    return bank.entitlement_package_name
  }
  if (bank.has_access) {
    return bank.name || '已开通'
  }
  return ''
}

/** 本题库当前套餐等级（仅 has_access 时有效） */
export function bankEntitlementLevel(bank) {
  if (!bank || !bank.has_access) {
    return 0
  }
  return parseInt(bank.entitlement_package_level, 10) || 0
}

export function formatBankVipDaysText(item) {
  if (!item || !item.has_access) {
    return '未开通'
  }
  if (item.days_text) {
    return item.days_text
  }
  const left = parseInt(item.days_left, 10)
  if (left < 0 || item.expire_text === '永久') {
    return '永久有效'
  }
  if (left > 0) {
    return `剩余${left}天`
  }
  return item.expire_text ? `至 ${item.expire_text}` : '已开通'
}

export function bankAccessStatusText(bank) {
  if (!bank) {
    return '未开通'
  }
  if (bank.has_access) {
    const pkg = bank.entitlement_package_name
    const exp = bank.expire_text || '已开通'
    return pkg ? `${pkg} · ${exp}` : exp
  }
  if (bank.purchase_blocked) {
    return '已开通更高等级题库'
  }
  return '未开通'
}
